module.exports = __webpack_public_path__ + "static/img/2.a1081f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/research/2.png
// module id = 8xAv
// module chunks = 13